export const SORTING_TYPES = Object.freeze({
  NO_SORTING: 'noSorting',
  ASC: 'asc',
  DESC: 'desc',
} as const);

type Keys = keyof typeof SORTING_TYPES;
export type SortingType = (typeof SORTING_TYPES)[Keys];
